import { Button, Grid, Theme, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ChannelItemEmail } from '../../../../sic-lib/types/ChannelItem';
import { setEmailThreadDrawer } from '../../../../store/contact';
import { useAppDispatch } from '../../../../store/hooks';

interface Props {
    channelItem: ChannelItemEmail;
}

export default React.memo(function EmailItem({ channelItem }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();
    const [readMore, setReadMore] = React.useState<boolean>(false);

    const handleBodyClick = () => {
        dispatch(setEmailThreadDrawer({ channelItem: channelItem }));
    };

    const handleReadMore = () => {
        setReadMore(!readMore);
    };

    return (
        <>
            <div onClick={handleBodyClick} className={classes.snippet}>
                <Typography variant="h6">{channelItem.subject}</Typography>
                <Typography variant="body1" display="block" whiteSpace="pre-wrap">
                    {channelItem.body?.length > 80 && !readMore
                        ? channelItem.body?.slice(0, 80)
                        : channelItem.body}
                </Typography>
            </div>
            {channelItem.body?.length > 80 && (
                <Grid display="flex" mt={2} justifyContent="flex-end">
                    <Button className={classes.btnReadMore} onClick={handleReadMore}>
                        {!readMore ? '+ Read More' : '- Less'}
                    </Button>
                </Grid>
            )}
        </>
    );
});

const useStyles = makeStyles()((theme: Theme) => ({
    snippet: {
        cursor: 'pointer',
        padding: theme.spacing(2),
    },
    btnReadMore: {
        color: theme.palette.primary.contrastText,
        justifyContent: 'flex-end',
    },
}));
